import { VdsButton } from '../../@vds';
import styles from './EmptyState.module.css';

import { Box, Button } from "@mui/material";

type EmptyStateComponent = React.FC<{
    icon?: React.ReactElement
    title: string
    description?: string
    action?: {
        onClick: () => void,
        text: string;
    }
}>;

export const EmptyState: EmptyStateComponent = (props) => {

    const {
        icon,
        title,
        description,
        action
    } = props;

    return (
        <Box className={styles.container}>
            <Box className={styles.icon}>
                {icon}
            </Box>
            <Box className={styles.title}>
                {title}
            </Box>
            {description && (
                <Box className={styles.description}>
                    {icon}
                </Box>
            )}
            {action && (
                <Box>
                    <VdsButton
                        color="primary"
                        variant="contained"
                        onClick={action.onClick}
                    >
                        {action.text}
                    </VdsButton>
                </Box>
            )}
        </Box>
    );
}
